module.exports = __webpack_public_path__ + "static/media/li-0.1addba36.png";